import { get, getV3, unwrapListEnvelope } from './';
import qs from 'qs';

// Full catalog country list (localized name, alpha2, lat/lon) from the v3
// endpoint. Flat DTOs only.
export const getCountries = () =>
  getV3('/countries?perPage=1000').then(unwrapListEnvelope);

export const getCountriesWithQuery = ({ filters }) =>
  get(`/countries/search?search=${filters.search ?? ''}`);

export const getAllCountriesByDmcId = ({ dmcId, filters = {} }) => {
  const organizationId = dmcId || filters.dmcId;
  const queryString = qs.stringify(filters);

  if (!organizationId) {
    return get(`/countries?${queryString}`);
  }

  return get(`/countries/${organizationId}?${queryString}`);
};
